import { createI18n } from 'vue-i18n';
import { getLanguagueFromUrl } from '@pfsc/core/ui-services/language.service';
import { commonI18n } from './common.i18n';

export const appI18n = createI18n({
  legacy: false, // must set `false`, to use Composition API
  locale: getLanguagueFromUrl(), // set default locale
  fallbackLocale: 'en', // set fallback locale
  messages: commonI18n,
});

export const globalTranslate = appI18n.global.t;
export const globalTranslateMessage = appI18n.global.tm;
